import { DepositStatusType } from '@golden/gdk-base';
import { AdminDepositStatusType } from '../enums/AdminDepositStatusType';
export const depositStatusMapAdminDepositStatus = {
    [DepositStatusType.IN_PROGRESS]: AdminDepositStatusType.IN_PROGRESS,
    [DepositStatusType.SUCCESSFUL]: AdminDepositStatusType.SUCCESSFUL,
    [DepositStatusType.FAIL]: AdminDepositStatusType.CANCEL,
    [DepositStatusType.EXPIRED]: AdminDepositStatusType.CANCEL,
    [DepositStatusType.CANCEL]: AdminDepositStatusType.CANCEL
};
//# sourceMappingURL=depositStatusMapAdminDepositStatus.js.map